import { MessageType } from 'api/MessageTypeAPI';
import { SubscriptionPolicy } from 'modules/graphql';
import { MESSAGE_TYPE_FIELDS_TEXT } from 'modules/channels/constants';
import { FrequencyCapFormValues } from './types';

const {
  VALUES: { CUSTOM, NONE },
} = MESSAGE_TYPE_FIELDS_TEXT;

export const createFrequencyCapPayload = (
  messageType: MessageType,
  values: FrequencyCapFormValues,
) => {
  const period = parseInt(`${values.period}`, 10);
  const numMessagesInPeriod = parseInt(`${values.numMessagesInPeriod}`, 10);
  const isOptionCustom = values.frequencyCapOption !== NONE;
  const rateLimit = isOptionCustom ? { period, numMessagesInPeriod } : null;

  // Usage of the message type update API needs to send DOI fields at the top level of the object in the update request
  const doiFields =
    messageType.subscriptionPolicy === SubscriptionPolicy.DoubleOptIn
      ? {
          brandName: messageType.subscriptionPolicyMetadata?.brandName,
          messagingInitiative: messageType.subscriptionPolicyMetadata?.messagingInitiative,
          disclaimerLink: messageType.subscriptionPolicyMetadata?.disclaimerLink,
          smsSenderId: messageType.subscriptionPolicyMetadata?.smsSenderId,
        }
      : {};

  return { ...messageType, ...doiFields, frequencyCap: rateLimit };
};

export const createFrequencyCapDefaultValues = (
  messageType: MessageType,
): FrequencyCapFormValues => {
  const { frequencyCap } = messageType;
  const days = frequencyCap?.periodDays;
  const messages = frequencyCap?.numMessagesInPeriod;

  const frequencyCapPeriod = !!days && days > 0 ? `${days}` : '';
  const messagePeriod = !!messages && messages > 0 ? `${messages}` : '';

  return {
    period: frequencyCapPeriod,
    numMessagesInPeriod: messagePeriod,
    frequencyCapOption: frequencyCap && !frequencyCap?.ignoreFrequencyCap ? CUSTOM : NONE,
  };
};
